import Keycloak from 'keycloak-js'
import { REACT_APP_KEYCLOAK_JSON } from './data/data';

const keycloakConfig = REACT_APP_KEYCLOAK_JSON;
export const keycloak = new Keycloak({
    url: keycloakConfig['auth-server-url'],
    realm: keycloakConfig['realm'],
    clientId: keycloakConfig['resource']
});

//login-required ou check-sso
export const keycloakInitConfig = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  redirectUri: window.location.origin //+ '/#/'
};